<template>
  <div class="overview">
    <income-chart />
    <div class="row overview__charts-container">
      <portfolio-chart class="portfolio-structure" />
      <cash-gradient class="cash" />
    </div>
    <pifs v-if="isUserVIP === false"></pifs>
    <asset-dynamics-chart class="asset-dynamics-chart" />
  </div>
</template>

<script>
import IncomeChart from "@/components/finance/IncomeChart";
import PortfolioChart from "@/components/finance/PortfolioChart";
import CashChart from "@/components/finance/CashChart";
import AssetDynamicsChart from "@/components/finance/AssetDynamicsChart";
import Pifs from "@/components/finance/Pifs";
import { mapGetters } from "vuex";

export default {
  components: {
    "income-chart": IncomeChart,
    "portfolio-chart": PortfolioChart,
    "cash-gradient": CashChart,
    "asset-dynamics-chart": AssetDynamicsChart,
    pifs: Pifs
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["pifs", "isUserVIP"])
  }
};
</script>

<style scoped>
.overview {
  padding: 35px 30px 0;
}

.portfolio-structure,
.cash {
  margin-top: 20px;
  width: 50%;
}

@media (max-width: 1100px) {
  .overview__charts-container {
    flex-direction: column;
  }

  .portfolio-structure,
  .cash {
    width: 100%;
  }
}

@media (max-width: 600px) {
  .overview {
    padding: 10px;
  }
}

.asset-dynamics-chart {
  position: relative;
  float: left;
  margin-top: 20px;
  width: 100%;
}
</style>
